import React, { useEffect, useState } from "react";

//styles
import "../include/css/bootstrap.min.css";
import "../include/css/style.css";
import "../include/css/dev.css";

//libs
import _ from "lodash";
import { Link, navigate } from "gatsby";

//component
import { Modal } from "react-bootstrap";
import { SEO } from "../components/seo";
import algoliasearch from "algoliasearch";
import Header from "../components/newDesign/header/header";

const client = algoliasearch(process.env.GATSBY_ALGOLIA_APP_ID, process.env.GATSBY_ALGOLIA_API_KEY);
const index = client.initIndex(process.env.GATSBY_ALGOLIA_LISTINGS_INDEX);

const Category = (props) => {
  const { data, pageContext } = props;
  const [showModal, setShowModal] = useState(false);
  const [catId, setCatId] = useState("");
  const [filteredCategory, setFilteredCategory] = useState({});
  const [showMobileFilter, setShowMobileFilter] = useState(false);
  const [remainingData, setRemainingData] = useState([]);

  const [activeCat, setActiveCat] = useState("");
  const [algoliaData, setAlgoliaData] = useState({});
  const [subCatData, setSubCatData] = useState({});
  const [filterData, setFilterData] = useState([]);
  const [searchVal, setSearchVal] = useState("");
  const [count, setCount] = useState(0);
  const [totalCount, setTotalCount] = useState(0);

  const subCategories = pageContext?.subCatData || {};

  const initialData = async () => {
    let facets = ["at_id"];

    const records = await index.search("", {
      facets: facets,
      facetFilters: ["at_id:6"],
      hitsPerPage: 0,
    });

    setCount(records?.nbHits);

    let facets1 = ["*"];

    const records1 = await index.search("", {
      facets: facets1,
      facetFilters: ["at_id:-6"],
      hitsPerPage: 0,
    });

    setAlgoliaData(records1.facets);
    setTotalCount(records1?.nbHits);
  };

  useEffect(() => {
    initialData();
    // this.setState({ data: records?.facets });
  }, []);

  useEffect(() => {
    if (activeCat?.length > 0) {
      // getSubData();
      setSubCatData(subCategories?.[`${activeCat[0]}`]);
      setSearchVal("");
      setFilterData([]);
    }
  }, [activeCat]);

  // useEffect(() => {
  //   if (!_.isEmpty(subCategories)) {
  //     const a = Object.entries(subCategories)?.filter((aa) => Object.keys(aa[1])?.length == 0);
  //     setRemainingData(a);
  //   }
  // }, [subCategories]);

  const toggleModal = () => {
    setShowModal(!showModal);
  };

  const toggleMobileFilter = (e) => {
    if (e) e.preventDefault();
    setShowMobileFilter(!showMobileFilter);
  };

  // const filterCategory = (id) => {
  //   const filteredCategory = pageContext.allCategories.find((es) => es.node.category_id === id);
  //   setFilteredCategory([]);
  // };

  return (
    <>
      <Header />
      <div class="custom-categories-heading-main">
        <div class="container-fluid">
          <div class="row  d-flex align-items-center">
            <div class="col-md-12 d-flex align-items-center" style={{ gap: "30px" }}>
              <h1>All Categories</h1>
              <div className="d-flex align-items-center">
                <Link to="/listings/index.cfm/catid/1001" className="link-butt-n-text cat-font-text">
                  For Sale ({totalCount})
                </Link>
                <div style={{ marginLeft: "7px", marginRight: "7px" }}> | </div>
                <Link className="link-butt-n-text cat-font-text" to="/listings/index.cfm/wanted">
                  Wanted ({count})
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="cdm-upper">
        <div class="container-fluid">
          <div class="row">
            <div class="col-md-12 extra-padding-bottom">
              <ul class="categories-nav-list d-flex flex-wrap">
                {" "}
                {Object.entries(subCategories)
                  ?.sort((a, b) => a[0]?.localeCompare(b[0]))
                  ?.map((v, i) => {
                    const id = v[0]?.split("_")?.[1];
                    const name = v[0]?.split("_")?.[0];
                    return name === "Pipe" ? (
                      <li class="cnl-item" key={i}>
                        <div class="cnl-box">
                          <h5>
                            <a
                              href={`javascript:void(0)`}
                              onClick={(event) => {
                                event.preventDefault();
                                navigate(`/pipe`);
                              }}
                            >
                              Pipe
                              {algoliaData?.["categories.lvl0"]?.[`Pipe`]
                                ? ` (${algoliaData?.["categories.lvl0"]?.[`Pipe`]})`
                                : ""}
                            </a>
                          </h5>
                        </div>
                      </li>
                    ) : name !== "Pipe" ? (
                      <li class="cnl-item" key={i}>
                        <div class="cnl-box">
                          <h5>
                            <a
                              href={`javascript:void(0)`}
                              onClick={(event) => {
                                event.preventDefault();
                                navigate(`/listings/index.cfm/catid/${id}`);
                              }}
                            >
                              {name}
                              {algoliaData?.["push_categories"]?.[`${name}_${id}`]
                                ? `(${algoliaData?.["push_categories"]?.[`${name}_${id}`]})`
                                : ""}
                            </a>
                          </h5>
                          <ul>
                            {Object.entries(subCategories?.[`${v[0]}`])
                              ?.slice(0, 5)
                              ?.map((esc) => {
                                const catName = esc[0]?.split(">")?.[1]?.split("_")[0];
                                const SubCatId = esc[0]?.split(">")?.[1]?.split("_")[1];
                                return SubCatId == 1280 ? (
                                  <>
                                    <li>
                                      <Link to={`/listings/index.cfm/catid/${SubCatId}`}>
                                        Aircraft Parts Lots {esc[1] ? `(${esc[1]})` : ``}
                                      </Link>
                                    </li>
                                    <li>
                                      <Link to={`/aviation-parts/`}>
                                        {catName} {esc[1] ? `(${process.env.GATSBY_AVIATION_COUNT})` : ``}
                                      </Link>
                                    </li>
                                  </>
                                ) : SubCatId == 1776 ? (
                                  <>
                                    <li>
                                      <Link to={`/pipe/`}>Pipe and Tubular (Oil and Gas)</Link>
                                    </li>
                                  </>
                                ) : (
                                  <li>
                                    <a
                                      href={`/listings/index.cfm/catid/${SubCatId}`}
                                      onClick={(e) => {
                                        e.preventDefault();
                                        if (SubCatId == 1776) {
                                          navigate(`/pipe`);
                                        } else {
                                          navigate(`/listings/index.cfm/catid/${SubCatId}`);
                                        }
                                      }}
                                    >
                                      {catName}{" "}
                                      <span>
                                        {algoliaData?.["push_categories"]?.[`${name}_${id} >${catName}_${SubCatId}`]
                                          ? `(${
                                              algoliaData?.["push_categories"]?.[
                                                `${name}_${id} >${catName}_${SubCatId}`
                                              ]
                                            })`
                                          : ""}
                                      </span>
                                    </a>
                                  </li>
                                );
                              })}
                          </ul>
                          {Object.keys(v[1]).length > 0 && (
                            <a
                              href="#!"
                              class="viewall_btn"
                              onClick={() => {
                                setCatId(id);
                                // filterCategory(id);
                                setActiveCat(v);
                                toggleModal();
                              }}
                            >
                              View All
                            </a>
                          )}
                        </div>
                      </li>
                    ) : (
                      ""
                    );
                  })}
              </ul>
            </div>
          </div>
        </div>
      </div>
      <div class="cdm-lower cdm-lower-new w-100">
        <div class="container-fluid">
          <div class="row">
            <div class="col-md-12 text-center">
              <Link to={"/all-categories"} style={{ color: "#fff" }}>
                VIEW ALL CATEGORIES
              </Link>
            </div>
          </div>
        </div>
      </div>
      <Modal
        className={"modal fade salvex-modal"}
        dialogClassName="modal-dialog modal-lg modal-dialog-scrollable"
        show={showModal}
        onHide={toggleModal}
        centered
      >
        <div className="modal-header">
          <h5 className="modal-title">
            {activeCat?.length > 0 ? `${activeCat?.[0]?.split("_")?.[0]}` : ""}{" "}
            {algoliaData?.["categories.lvl0"]?.[`${activeCat[0]}`]
              ? `(${algoliaData?.["categories.lvl0"]?.[`${activeCat[0]}`]})`
              : ""}
          </h5>
          <div className="searchInput">
            <input
              type="text"
              placeholder="Search"
              className="form-control"
              value={searchVal}
              onChange={(e) => {
                const value = e.target.value;
                setSearchVal(value);
                if (value === "") {
                  setFilterData(subCatData);
                  return;
                } else {
                  const a = Object.keys(subCatData)?.filter((ih) => ih.toLowerCase().includes(value.toLowerCase()));

                  setFilterData(a);
                }
              }}
            />
          </div>
          <div className="close-btn" data-bs-dismiss="modal" onClick={toggleModal}>
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M18 6L6 18" stroke="black" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
              <path d="M6 6L18 18" stroke="black" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
            </svg>
          </div>
        </div>
        <div className="modal-body">
          <ul className="three-column-row w-100">
            {filterData?.length > 0
              ? filterData?.map((v) => {
                  const descp = v?.split(">")?.[1]?.split("_")?.[0];
                  const id = v?.split(">")?.[1]?.split("_")?.[1];
                  return (
                    <li className="tcr-item">
                      <div className="form-check d-flex align-items-center p-0">
                        <a
                          href={`/listings/index.cfm/catid/${id}`}
                          onClick={(e) => {
                            e.preventDefault();
                            navigate(`/listings/index.cfm/catid/${id}`);
                          }}
                          className="form-check-label"
                        >
                          {descp}{" "}
                          {algoliaData?.["push_categories"]?.[
                            `${activeCat?.[0]?.split("_")?.[0]}_${activeCat?.[0]?.split("_")?.[1]} >${descp}_${id}`
                          ]
                            ? `(${
                                algoliaData?.["push_categories"]?.[
                                  `${activeCat?.[0]?.split("_")?.[0]}_${
                                    activeCat?.[0]?.split("_")?.[1]
                                  } >${descp}_${id}`
                                ]
                              })`
                            : ""}
                        </a>
                      </div>
                    </li>
                  );
                })
              : Object.keys(subCatData)?.map((v) => {
                  const descp = v?.split(">")?.[1]?.split("_")?.[0];
                  const id = v?.split(">")?.[1]?.split("_")?.[1];
                  return (
                    <li className="tcr-item">
                      <div className="form-check d-flex align-items-center p-0">
                        <a
                          href={`/listings/index.cfm/catid/${id}`}
                          onClick={(e) => {
                            e.preventDefault();
                            navigate(`/listings/index.cfm/catid/${id}`);
                          }}
                          className="form-check-label"
                        >
                          {descp}{" "}
                          {algoliaData?.["push_categories"]?.[
                            `${activeCat?.[0]?.split("_")?.[0]}_${activeCat?.[0]?.split("_")?.[1]} >${descp}_${id}`
                          ]
                            ? `(${
                                algoliaData?.["push_categories"]?.[
                                  `${activeCat?.[0]?.split("_")?.[0]}_${
                                    activeCat?.[0]?.split("_")?.[1]
                                  } >${descp}_${id}`
                                ]
                              })`
                            : ""}
                        </a>
                      </div>
                    </li>
                  );
                })}
          </ul>
        </div>
      </Modal>
    </>
  );
};

export default Category;
export const Head = ({ location }) => (
  <SEO
    canonical={`https://www.salvex.com${location.pathname}`}
    title="Category | Salvex"
    description="Browse listings by Category"
  />
);
